import { render, staticRenderFns } from "./DocumentsPDFViewer.vue?vue&type=template&id=145a4dd6&lang=pug"
import script from "./DocumentsPDFViewer.vue?vue&type=script&lang=js"
export * from "./DocumentsPDFViewer.vue?vue&type=script&lang=js"
import style0 from "./DocumentsPDFViewer.vue?vue&type=style&index=0&id=145a4dd6&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports